export const anyConditionId = 'any';
